import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableContainer from "../Tables/TableContainer";
import TableCell from "../../pages/BillingAndPayments/components/TableCell";
import { useTranslationApp } from "../../lib/i18next";
import {
  MODAL_CREDITS_USAGE_DETAILED_TABLE_BY_ADVERTISER_TITLE,
  MODAL_CREDITS_USAGE_DETAILED_TABLE_BY_USER_TITLE,
  MODAL_CREDITS_USAGE_DETAILED_COLUMN_ADVERTISER,
  MODAL_CREDITS_USAGE_DETAILED_COLUMN_USER,
  MODAL_CREDITS_USAGE_DETAILED_COLUMN_CREDITS_SPENT,
  MODAL_CREDITS_USAGE_DETAILED_LOADING,
  MODAL_CREDITS_USAGE_DETAILED_EMPTY,
} from "../../i18n/keysTranslations";

const CreditsUsageBreakdownTables = ({
  loading = false,
  byAdvertiser = [],
  byUser = [],
}) => {
  const { t } = useTranslationApp();

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
      <Box>
        <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1.5 }}>
          {t(MODAL_CREDITS_USAGE_DETAILED_TABLE_BY_ADVERTISER_TITLE)}
        </Typography>
        <TableContainer
          loading={loading}
          loadingText={MODAL_CREDITS_USAGE_DETAILED_LOADING}
          emptyText={MODAL_CREDITS_USAGE_DETAILED_EMPTY}
          keys={byAdvertiser}
          hasPagination={false}
          ariaLabel="credits-by-advertiser"
          sxContainer={{ boxShadow: "none" }}
        >
          <TableHead>
            <TableRow>
              <TableCell isHeader={true} sx={{ pl: "16px !important" }}>
                {t(MODAL_CREDITS_USAGE_DETAILED_COLUMN_ADVERTISER)}
              </TableCell>
              <TableCell isHeader={true} align="right">
                {t(MODAL_CREDITS_USAGE_DETAILED_COLUMN_CREDITS_SPENT)}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {byAdvertiser.map((row, index) => {
              const isLastRow = index === byAdvertiser.length - 1;
              return (
                <TableRow key={row.id}>
                  <TableCell
                    indexRow={index}
                    isLastRow={isLastRow}
                    sx={{ pl: "16px !important" }}
                  >
                    {row.name}
                  </TableCell>
                  <TableCell
                    indexRow={index}
                    isLastRow={isLastRow}
                    align="right"
                  >
                    {row.creditsSpent}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </TableContainer>
      </Box>

      <Box>
        <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1.5 }}>
          {t(MODAL_CREDITS_USAGE_DETAILED_TABLE_BY_USER_TITLE)}
        </Typography>
        <TableContainer
          loading={loading}
          loadingText={MODAL_CREDITS_USAGE_DETAILED_LOADING}
          emptyText={MODAL_CREDITS_USAGE_DETAILED_EMPTY}
          keys={byUser}
          hasPagination={false}
          ariaLabel="credits-by-user"
          sxContainer={{ boxShadow: "none" }}
        >
          <TableHead>
            <TableRow>
              <TableCell isHeader={true} sx={{ pl: "16px !important" }}>
                {t(MODAL_CREDITS_USAGE_DETAILED_COLUMN_USER)}
              </TableCell>
              <TableCell isHeader={true} align="right">
                {t(MODAL_CREDITS_USAGE_DETAILED_COLUMN_CREDITS_SPENT)}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {byUser.map((row, index) => {
              const isLastRow = index === byUser.length - 1;
              return (
                <TableRow key={row.id}>
                  <TableCell
                    indexRow={index}
                    isLastRow={isLastRow}
                    sx={{ pl: "16px !important" }}
                  >
                    {row.email}
                  </TableCell>
                  <TableCell
                    indexRow={index}
                    isLastRow={isLastRow}
                    align="right"
                  >
                    {row.creditsSpent}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </TableContainer>
      </Box>
    </Box>
  );
};

export default CreditsUsageBreakdownTables;
